<wk-ifirm-notes-panel>
    <wk-notes-panel [id]="id()" placeholder="iFirmTaxNotes.Placeholder" />
</wk-ifirm-notes-panel>
